'use client';
import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _extends } from "@swc/helpers/_/_extends";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { zodResolver } from '@hookform/resolvers/zod';
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from '@kamio/ui/components/form';
import { Input } from '@kamio/ui/components/input';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { useForm } from 'react-hook-form';
import { toast } from 'sonner';
import { z } from 'zod';
import { LoadingButton } from '../loading-button';
// Duplication due to nextjs issue, cannot export objects from server functions...
const signInSchema = z.object({
    email: z.string({
        message: 'Required'
    }).email(),
    password: z.string({
        message: 'Required'
    }).min(8, {
        message: 'Password must be at least 8 characters'
    })
});
export function SignInForm({ signIn, pathAfterSignIn = '/' }) {
    const router = useRouter();
    const form = useForm({
        resolver: zodResolver(signInSchema),
        mode: 'onChange',
        defaultValues: {
            email: '',
            password: ''
        }
    });
    function onSubmit(data) {
        return _async_to_generator(function*() {
            try {
                const result = yield signIn({
                    email: data.email,
                    password: data.password
                });
                if (result.error) {
                    throw new Error(result.error);
                }
                toast.success('Signed In Sucessfully.');
                router.push(pathAfterSignIn);
            } catch (ex) {
                if (ex instanceof Error) {
                    toast.error(`An Error Occured: ${ex.message}`);
                }
            }
        })();
    }
    return /*#__PURE__*/ _jsx(Form, _extends({}, form, {
        children: /*#__PURE__*/ _jsx("form", {
            onSubmit: form.handleSubmit(onSubmit),
            className: "animate-in",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "space-y-2",
                children: [
                    /*#__PURE__*/ _jsx(FormField, {
                        control: form.control,
                        name: "email",
                        render: ({ field })=>/*#__PURE__*/ _jsxs(FormItem, {
                                children: [
                                    /*#__PURE__*/ _jsx(FormLabel, {
                                        children: "Email"
                                    }),
                                    /*#__PURE__*/ _jsx(FormControl, {
                                        children: /*#__PURE__*/ _jsx(Input, _extends({}, field, {
                                            autoComplete: "email username"
                                        }))
                                    }),
                                    /*#__PURE__*/ _jsx(FormMessage, {})
                                ]
                            })
                    }),
                    /*#__PURE__*/ _jsx(FormField, {
                        control: form.control,
                        name: "password",
                        render: ({ field })=>/*#__PURE__*/ _jsxs(FormItem, {
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex items-center justify-between",
                                        children: [
                                            /*#__PURE__*/ _jsx(FormLabel, {
                                                children: "Password"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "text-sm",
                                                children: /*#__PURE__*/ _jsx(Link, {
                                                    href: "/auth/forgot-password",
                                                    className: "hover:text-primary-light dark:hover:text-primary-dark text-xs font-semibold text-gray-400",
                                                    tabIndex: 100,
                                                    children: "Forgot password?"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(FormControl, {
                                        children: /*#__PURE__*/ _jsx(Input, _extends({}, field, {
                                            type: "password",
                                            autoComplete: "current-password"
                                        }))
                                    }),
                                    /*#__PURE__*/ _jsx(FormMessage, {})
                                ]
                            })
                    }),
                    /*#__PURE__*/ _jsx(LoadingButton, {
                        className: "w-full",
                        type: "submit",
                        isLoading: form.formState.isSubmitting,
                        children: "Sign in"
                    })
                ]
            })
        })
    }));
}
